import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type MessageSearchResultsQueryVariables = Types.Exact<{
  criteria?: Types.InputMaybe<Types.MessageSearchQueryCriteria>;
  eventId?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type MessageSearchResultsQuery = {
  __typename?: 'Query';
  messageSearchResults: {
    __typename?: 'MessageSearchResultContainer';
    allResult: {
      __typename?: 'MessageResult';
      messages: Array<{
        __typename?: 'Message';
        id: string;
        type: Types.MessageType;
        status: Types.MessageStatus;
        messageId?: string | null;
        sentOn?: { __typename?: 'Date'; milliseconds: number } | null;
        lastStatusUpdate?: { __typename?: 'Date'; milliseconds: number } | null;
        statusHistory: Array<{ __typename?: 'MessageStatusRecord'; status: Types.MessageStatus; date: { __typename?: 'Date'; milliseconds: number } }>;
        recipient: {
          __typename?: 'RecipientInfo';
          personId?: string | null;
          email?: string | null;
          phoneNumber?: string | null;
          guestKey?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          displayName?: string | null;
        };
        messageBatch?: { __typename?: 'MessageBatch'; id: string; displayLabel: string; messageType?: string | null } | null;
      }>;
    };
  };
};

export type GetContactsByGuestKeyListQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  guestKeys: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;

export type GetContactsByGuestKeyListQuery = {
  __typename?: 'Query';
  getContactsByGuestKeyList?: Array<{
    __typename?: 'Contact';
    id: string;
    firstName: string;
    lastName: string;
    guestKey?: string | null;
    email?: string | null;
    phoneNumber?: Array<{ __typename?: 'ContactPhoneNumber'; id: string; number: string } | null> | null;
  } | null> | null;
};

export type StationeryPrintOrderByIdQueryVariables = Types.Exact<{
  orderId: Types.Scalars['ID'];
}>;

export type StationeryPrintOrderByIdQuery = {
  __typename?: 'Query';
  stationeryPrintOrderById?: {
    __typename?: 'StationeryPrintOrder';
    id: string;
    orderNumber: string;
    printCardFrontPreviewUrl: string;
    cardDraftJSONBlob?: any | null;
    cardDraft?: {
      __typename?: 'StationeryDraft';
      id: string;
      stationeryTemplate: { __typename?: 'StationeryTemplate'; id: string; themeId: string; category: Types.StationeryTemplateCategoryEnum; name?: string | null };
    } | null;
  } | null;
};

export type StationeryDigitalCardViewByOrderIdQueryVariables = Types.Exact<{
  cardViewInput?: Types.InputMaybe<Types.GetStationeryDigitalViewInput>;
}>;

export type StationeryDigitalCardViewByOrderIdQuery = {
  __typename?: 'Query';
  stationeryDigitalCardView: Array<{ __typename?: 'StationeryDigitalView'; id: number; personId: string; src: Types.StationeryDigitalViewSource }>;
};

export const MessageSearchResultsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MessageSearchResults' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MessageSearchQueryCriteria' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messageSearchResults' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'criteria' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allResult' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messages' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sentOn' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastStatusUpdate' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'statusHistory' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'date' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recipient' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'personId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'guestKey' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'messageBatch' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'messageType' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMessageSearchResultsQuery__
 *
 * To run a query within a React component, call `useMessageSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageSearchResultsQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useMessageSearchResultsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessageSearchResultsQuery, MessageSearchResultsQueryVariables>) {
  return ApolloReactHooks.useQuery<MessageSearchResultsQuery, MessageSearchResultsQueryVariables>(MessageSearchResultsDocument, baseOptions);
}
export function useMessageSearchResultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessageSearchResultsQuery, MessageSearchResultsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<MessageSearchResultsQuery, MessageSearchResultsQueryVariables>(MessageSearchResultsDocument, baseOptions);
}
export type MessageSearchResultsQueryHookResult = ReturnType<typeof useMessageSearchResultsQuery>;
export type MessageSearchResultsLazyQueryHookResult = ReturnType<typeof useMessageSearchResultsLazyQuery>;
export type MessageSearchResultsQueryResult = Apollo.QueryResult<MessageSearchResultsQuery, MessageSearchResultsQueryVariables>;
export const GetContactsByGuestKeyListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContactsByGuestKeyList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'guestKeys' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getContactsByGuestKeyList' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'guestKeys' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'guestKeys' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneNumber' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetContactsByGuestKeyListQuery__
 *
 * To run a query within a React component, call `useGetContactsByGuestKeyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsByGuestKeyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsByGuestKeyListQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestKeys: // value for 'guestKeys'
 *   },
 * });
 */
export function useGetContactsByGuestKeyListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactsByGuestKeyListQuery, GetContactsByGuestKeyListQueryVariables>) {
  return ApolloReactHooks.useQuery<GetContactsByGuestKeyListQuery, GetContactsByGuestKeyListQueryVariables>(GetContactsByGuestKeyListDocument, baseOptions);
}
export function useGetContactsByGuestKeyListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactsByGuestKeyListQuery, GetContactsByGuestKeyListQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetContactsByGuestKeyListQuery, GetContactsByGuestKeyListQueryVariables>(GetContactsByGuestKeyListDocument, baseOptions);
}
export type GetContactsByGuestKeyListQueryHookResult = ReturnType<typeof useGetContactsByGuestKeyListQuery>;
export type GetContactsByGuestKeyListLazyQueryHookResult = ReturnType<typeof useGetContactsByGuestKeyListLazyQuery>;
export type GetContactsByGuestKeyListQueryResult = Apollo.QueryResult<GetContactsByGuestKeyListQuery, GetContactsByGuestKeyListQueryVariables>;
export const StationeryPrintOrderByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StationeryPrintOrderById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryPrintOrderById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'orderId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'printCardFrontPreviewUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cardDraftJSONBlob' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cardDraft' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stationeryTemplate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useStationeryPrintOrderByIdQuery__
 *
 * To run a query within a React component, call `useStationeryPrintOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationeryPrintOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationeryPrintOrderByIdQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useStationeryPrintOrderByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StationeryPrintOrderByIdQuery, StationeryPrintOrderByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<StationeryPrintOrderByIdQuery, StationeryPrintOrderByIdQueryVariables>(StationeryPrintOrderByIdDocument, baseOptions);
}
export function useStationeryPrintOrderByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StationeryPrintOrderByIdQuery, StationeryPrintOrderByIdQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<StationeryPrintOrderByIdQuery, StationeryPrintOrderByIdQueryVariables>(StationeryPrintOrderByIdDocument, baseOptions);
}
export type StationeryPrintOrderByIdQueryHookResult = ReturnType<typeof useStationeryPrintOrderByIdQuery>;
export type StationeryPrintOrderByIdLazyQueryHookResult = ReturnType<typeof useStationeryPrintOrderByIdLazyQuery>;
export type StationeryPrintOrderByIdQueryResult = Apollo.QueryResult<StationeryPrintOrderByIdQuery, StationeryPrintOrderByIdQueryVariables>;
export const StationeryDigitalCardViewByOrderIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StationeryDigitalCardViewByOrderId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cardViewInput' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetStationeryDigitalViewInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryDigitalCardView' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'cardViewInput' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'personId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'src' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useStationeryDigitalCardViewByOrderIdQuery__
 *
 * To run a query within a React component, call `useStationeryDigitalCardViewByOrderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStationeryDigitalCardViewByOrderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStationeryDigitalCardViewByOrderIdQuery({
 *   variables: {
 *      cardViewInput: // value for 'cardViewInput'
 *   },
 * });
 */
export function useStationeryDigitalCardViewByOrderIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<StationeryDigitalCardViewByOrderIdQuery, StationeryDigitalCardViewByOrderIdQueryVariables>,
) {
  return ApolloReactHooks.useQuery<StationeryDigitalCardViewByOrderIdQuery, StationeryDigitalCardViewByOrderIdQueryVariables>(
    StationeryDigitalCardViewByOrderIdDocument,
    baseOptions,
  );
}
export function useStationeryDigitalCardViewByOrderIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StationeryDigitalCardViewByOrderIdQuery, StationeryDigitalCardViewByOrderIdQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<StationeryDigitalCardViewByOrderIdQuery, StationeryDigitalCardViewByOrderIdQueryVariables>(
    StationeryDigitalCardViewByOrderIdDocument,
    baseOptions,
  );
}
export type StationeryDigitalCardViewByOrderIdQueryHookResult = ReturnType<typeof useStationeryDigitalCardViewByOrderIdQuery>;
export type StationeryDigitalCardViewByOrderIdLazyQueryHookResult = ReturnType<typeof useStationeryDigitalCardViewByOrderIdLazyQuery>;
export type StationeryDigitalCardViewByOrderIdQueryResult = Apollo.QueryResult<StationeryDigitalCardViewByOrderIdQuery, StationeryDigitalCardViewByOrderIdQueryVariables>;
